import { hostname } from 'helpers/hostname'

export const request = async (method, url, body = null, headers = {}) => {
  try {
    const res = await fetch(`${hostname()}/${url}`, {
      method: method.toUpperCase(),
      credentials: 'include',
      // headers,
      body,
    })

    const json = await res.json().catch(() => null)

    if (!res.ok) {
      return {
        ...json,
        status: res.status,
      }
    }

    return json
  } catch (e) {
    console.log(e)
    return {
      error: true,
      message: e.message,
    }
  }
}

export const getData = (url, headers) =>
  request('GET', url, null, headers)

export const postData = (url, body, headers) =>
  request('POST', url, body, headers)
